import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@markbase/modouls-shared-frontend/widgets/client-errors/deploy-update-screen.css';
import App from './App';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import relativeTime from 'dayjs/plugin/relativeTime';
import ErrorBoundary from './components/Common/ErrorBoundary';
import { prefetchCriticalData, reportPrefetchFailure } from './utils/prefetch';
import { devLogApiError } from './utils/devLogApiError';

// Инициализация dayjs для корректной работы fromNow() и локализации
dayjs.extend(relativeTime);
dayjs.locale('ru');

const IS_DEV_GLOBAL = process.env.NODE_ENV === 'development';

// ✅ Глобальный обработчик ошибок (только development — без шума console.error в проде)
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (!IS_DEV_GLOBAL) return;
    if (event.error) {
      devLogApiError('Глобальный перехват: window.error', event.error);
    } else {
      // eslint-disable-next-line no-console
      console.warn('[Глобальный перехват]', event.message, event.filename, event.lineno);
    }
    if (event.error?.message?.includes("Cannot access 'I' before initialization")) {
      // eslint-disable-next-line no-console
      console.warn('[Глобальный перехват] Возможна проблема инициализации (lazy/circular)');
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const msg = (reason?.message || String(reason || '')).toLowerCase();
    // Не логируем как ошибку приложения отказы от расширений (MetaMask и т.п.) — они не относятся к коду приложения
    if (msg.includes('metamask') || msg.includes('extension not found') || (reason?.stack && String(reason.stack).includes('inpage.js'))) {
      event.preventDefault();
      return;
    }
    if (!IS_DEV_GLOBAL) return;
    if (reason instanceof Error) {
      devLogApiError('Глобальный перехват: unhandledrejection', reason);
    } else {
      // eslint-disable-next-line no-console
      console.warn('[Необработанный отказ Promise]', reason);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Инициализация prefetching после загрузки приложения
// ✅ ОПТИМИЗИРОВАНО: Prefetch запускается с большой задержкой и не блокирует ничего
if (typeof window !== 'undefined') {
  const initPrefetch = () => {
    // Запускаем prefetch только если страница полностью загружена
    // и только через 3 секунды после загрузки
    if (document.readyState === 'complete') {
      setTimeout(() => {
        // Инициализируем prefetch в фоне, не блокируя ничего
        requestIdleCallback ? requestIdleCallback(() => {
          prefetchCriticalData().catch((e) => reportPrefetchFailure('idle critical', e));
        }, { timeout: 5000 }) : setTimeout(() => {
          prefetchCriticalData().catch((e) => reportPrefetchFailure('idle critical (fallback timer)', e));
        }, 100);
      }, 3000); // 3 секунды задержки
    }
  };

  // Запускаем только после полной загрузки
  if (document.readyState === 'complete') {
    initPrefetch();
  } else {
    window.addEventListener('load', initPrefetch, { once: true });
  }
}